<template>
    <div class="size-full bgcolor-inherit" >
        <input type="checkbox" class="lw-topbar-hamburger-check js-hamburger-check" name="checkbox" :id="hamburgerId" @click.stop ref="hamInput">
        <label class="lw-topbar-hamburger js-hamburger-check" :for="hamburgerId"></label>
        <div class="js-lw-topbar-hamburger lw-topbar-hamburger-menu learnworlds-align-center bgcolor-inherit flex flex-d-col j-c-c">
            <div class="lw-topbar-hamburger-menu-item" v-for="(hamburgerOption,index) in hamburgerContentData()" :key="index">
                <component
                        class="learnworlds-main-text-large"
                        :is="hamburgerOptionTag(hamburgerOption)"
                        :class="hamburgerOption.className"
                        :href="!hamburgerOption.href ? null : allowClicks ? hamburgerOption.href  : 'javascript:void(0)'"
                        :data-target-id="hamburgerOption.id || null"
                        @click="allowClicks && hamburgerOption.linkData ? handleLinkSelection(hamburgerOption.linkData) : null"
                >{{hamburgerOption.text}}</component>
            </div>
        </div>
    </div>
</template>
<script>
    import LinksMixin from "../../../author/pagesbuilder/mixins/LinksMixin";

    export default {
        name: "HamburgerMenu.vue",
        mixins: [LinksMixin],
        data () {
            return {
                componentType: "hamburger-menu",
                rendersWithVue: true,
                hamburgerOptionsDisplay : false
            }
        },
        computed: {
            getHamburgerContentFromNodeStates () {
                let topbarStatus = this.topbarStatus;
                let nodeStates = [];

                if (this.inTopbar && topbarStatus) {
                    let topbarId = this.inTopbar[0].id;
                    let topbarState = this.findNodeState(topbarId);

                    if (!topbarState) {
                        return nodeStates;
                    }
                    let nestedNodesWithIds = topbarState.myNode.querySelectorAll("[id]"); //find any nested node that has to be shown in hamburger by querySelector to keep the order of nodes correct

                    nestedNodesWithIds.forEach(node => {
                        let nodeId = node.getAttribute("id");
                        let nodeState = this.findNodeState(nodeId);

                        if (nodeState && nodeState.hasHamburgerContent) {
                            nodeStates.push(nodeState);
                        }

                    })
                }

                return nodeStates;
            },
            hamburgerId () {
                return this.myId ? "hamburger_" + this.myId : window.createTimeID()
            }
        },
        methods: {
            componentCreationCallback() {
                this.$forceUpdate();
            },
            hamburgerContentData () {
                let states = this.getHamburgerContentFromNodeStates;
                let dataModel = [];

                states.forEach( state => {
                    dataModel = dataModel.concat(state.getHamburgerContent());
                })
                return dataModel;
            },
            hamburgerOptionTag(hamburgerOptionData){
                return hamburgerOptionData.href ? "a" : "div";
            },
            setHamburgerOptionsDisplay (flag) {
                this.hamburgerOptionsDisplay = flag;
            },
            handleSelection (force) {
                if (force) {
                    this.setElementStatus({selectedElement : this.componentNode});
                }
            },
            handleClick (event) {
                if (!event.target.classList.contains('js-hamburger-check')) {
                    return;
                }

                if (this.hamburgerOptionsDisplay) {
                    this.hideHamburgerMenu();
                } else {
                    this.showHamburgerMenu();

                }

                this.setElementStatus({
                    selectedElement: null,
                    selectedSection: null
                });
            },
            hideHamburgerMenu (force) {
                document.querySelector(`${this.pageWrapperId}`).style.overflow = null;
                this.sectionNode.classList.remove("with-ham-menu");
                this.setHamburgerOptionsDisplay(false);

                //force is used when invoking without click , click from code to trigger native input functionality
                if (force) {
                    this.$refs['hamInput'].click();
                }
            },
            showHamburgerMenu (force) {
                document.querySelector(`${this.pageWrapperId}`).style.overflow = "hidden";
                this.sectionNode.classList.add("with-ham-menu");
                this.setHamburgerOptionsDisplay(true);

                //force is used when invoking without click
                if (force) {
                    this.$refs['hamInput'].click();
                }
            },
        },
    }
</script>

